












































































import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppHlsVideo from '@/components/AppHlsVideo.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'

import { Common } from '@/mixins'

@Component({
  components: {
    AppHlsVideo,
    AppRouterLink
  }
})
export default class extends Mixins(Common) {
  @Prop(Object) readonly option!: { saleExpiredAt: number }
  @Prop(Object) readonly feed!: {
    id: string;
    user: any;
    medias: {
      subMedias: {
        type: string;
        ownerUseType: string;
        path: string;
      }[];
    }[];
    completedJobCount: null;
  }

  @Prop(String) readonly title!: string
  @Prop(Number) readonly rank!: number
  @Prop(Boolean) readonly fullSquare!: boolean
  @Prop(Boolean) readonly fullVertical!: boolean
  @Prop(Number) readonly now!: number

  isVisible = false

  get thumbnail () {
    return this.feedThumbnail(this.feed)
  }

  visibilityChanged (isVisible: boolean) {
    this.isVisible = isVisible
    if (isVisible) {
      this.$emit('visible', this.feed.id)
    }
  }
}
